export default "__VITE_ASSET__FQ4VR6au__"